// extracted by extract-css-chunks-webpack-plugin
module.exports = {"divider":"divider_iO5hD","externalLink":"externalLink_3BsrS"};